import gql from 'graphql-tag'

export const fetchBannersConfigQuery = gql(`
  query {
    getPortalConfig {
      banner_rotation
    }
  }
`)
